import {
  CheckoutCard,
  CheckoutCardContent,
  CheckoutCardTitle,
} from "../../../../Components/Checkout/CheckoutCard";
import { Trans, useTranslation } from "react-i18next";
import React, { useState } from "react";
import { formatCurrency } from "../../../../../utils";
import { useCheckout } from "../../../../providers/CheckoutProvider";
import Box from "@mui/material/Box";
import {
  Checkbox,
  FormControlLabel,
  FormHelperText,
  TextField,
} from "@mui/material";
import TermsOfPurchaseDialog from "../../../../Components/Checkout/TermsOfPurchaseDialog";
import LoadingButton from "../../../../../components/LoadingButton";
import Link from "@mui/material/Link";

const VerifyAndFinishCard = ({ children }) => {
  const {
    options,
    setOrderComment,
    orderComment,
    termsOfPurchase,
    cart,
    deliveryOption,
    paymentOption,
    createTransaction,
    currentStep,
    isCreatingTransaction,
    createTransactionError,
  } = useCheckout();
  const [showTermsOfPurchase, setShowTermsOfPurchase] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const { t } = useTranslation();

  const handleOpenTermsOfPurchase = (e) => {
    setShowTermsOfPurchase(true);
    e.stopPropagation();
  };

  if (currentStep != "confirm-order") {
    return (
      <CheckoutCard>
        <CheckoutCardTitle active={false} disabled={true}>
          <Trans>3. Summary and finish</Trans>
        </CheckoutCardTitle>
      </CheckoutCard>
    );
  }

  const termsOfServiceLabel = (
    <Trans>
      I accept the{" "}
      <Link
        href="javascript:void(0)"
        onClick={(e) => setShowTermsOfPurchase(true)}
      >
        terms of purchase
      </Link>
    </Trans>
  );

  console.log("Button disabled", termsAccepted);

  return (
    <CheckoutCard>
      <CheckoutCardTitle active={true}>
        <Trans>3. Summary and finish</Trans>
      </CheckoutCardTitle>

      <CheckoutCardContent>
        {children}

        {!options.disableOrderComment && (
          <Box mt={2} mb={2} display="flex" justifyContent="center">
            <TextField
              rows={4}
              multiline
              variant="outlined"
              label={t("Order comment")}
              fullWidth
              value={orderComment}
              onChange={(e) => setOrderComment(e.target.value)}
            />
          </Box>
        )}

        <Box mt={3} mb={3} display="flex" justifyContent="center">
          <FormControlLabel
            control={
              <Checkbox
                type="checkbox"
                name="termsAccepted"
                checked={termsAccepted}
                onChange={() => setTermsAccepted(!termsAccepted)}
              />
            }
            label={termsOfServiceLabel}
          />
        </Box>

        {createTransactionError && (
          <FormHelperText error={true}>
            {createTransactionError}
          </FormHelperText>
        )}

        <Box mt={3} mb={3}>
          <LoadingButton
            isLoading={isCreatingTransaction}
            fullWidth
            variant="primary"
            color="primary"
            onClick={createTransaction}
            disabled={!paymentOption || !deliveryOption || !termsAccepted}
          >
            <Trans>
              Buy now {{ "%s": formatCurrency(cart.summary.totalPrice) }}
            </Trans>
          </LoadingButton>
        </Box>
      </CheckoutCardContent>
      {showTermsOfPurchase && (
        <TermsOfPurchaseDialog
          termsOfPurchase={termsOfPurchase}
          onClose={() => setShowTermsOfPurchase(false)}
        />
      )}
    </CheckoutCard>
  );
};

export default VerifyAndFinishCard;
